export default "__VITE_ASSET__A$o5t6oS__"